<template>
    <section class="modal-mask superadmin-modal modal-confirmation">
        <div class="modal-mask-inner" @click="closeOpenModal"></div>
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="title">{{ title }}</div>

                <div class="font-14">{{ description }}</div>

                <div class="actions">
                    <div @click="decline.callback()" class="new-btn">{{ decline.text | lang }}</div>
                    <div
                        v-if="accept"
                        @click="isDoingAction ? null : accept.callback()"
                        :class="['new-btn', { 'is-creating': isDoingAction }]"
                    >
                        <span v-if="!isDoingAction">{{ accept.text | lang }}</span>
                        <i v-else class="material-icons loading">autorenew</i>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Confirmation",
        props: {
            title: String,
            description: String,
            decline: {
                type: Object,
                default: () => {
                    return {
                        text: 'general.cancel',
                        callback: () => this.closeOpenModal()
                    }
                }
            },
            accept: Object
        },
        data() {
            return {
                isDoingAction: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    .modal-confirmation {
        .font-14 {
            font-size: 14px;
            line-height: 24px;
        }

        .modal-container {
            width: 433px;
            padding: 24px;
            background: #F5FBF5;
            color: #171D19;

            .title {
                padding-bottom: 24px;
                font-size: 24px;
                line-height: 32px;
                font-family: PlutoSansRegular;
                font-weight: 400;
            }

            .new-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 84px;
                margin-left: 8px;
                padding: 10px 12px;
                border-radius: 4px;
                font-size: 14px;
                line-height: 19px;
                font-weight: 500;
                text-transform: uppercase;
                font-family: PlutoSansMedium;
                cursor: pointer;
                color: #226A4C;

                &:hover {
                    background: #e9e9e9;
                }

                &.filled:not(.is-disabled) {
                    color: #fff;
                    background: #226A4C;
                }

                &.is-creating {
                    font-size: 18px;
                    text-align: center;
                }

                &.is-disabled {
                    pointer-events: none;
                    user-select: none;
                    color: rgba($black-1, .25);
                }

                &.delete {
                    margin-right: auto;
                    color: $error;
                }
            }

            .actions {
                display: flex;
                justify-content: flex-end;
                margin-top: 24px;
            }
        }
    }
</style>